import React from "react";
import { useI18n, NLink } from "@/i18n/I18nProvider";
import { ArrowRight } from "lucide-react";

const SPORTS_IMG = {
  soccer: "https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=1200&q=80",
  golf: "https://images.unsplash.com/photo-1530028828-25e8270793c5?w=1200&q=80",
  tennis: "https://images.unsplash.com/photo-1622279457486-62dcc4a431d6?w=1200&q=80",
  swimming: "https://images.unsplash.com/photo-1622629797619-c100e3e67e2e?w=1200&q=80",
  volleyball: "https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?w=1200&q=80",
  basketball: "https://images.unsplash.com/photo-1546519638-68e109498ffc?w=1200&q=80",
  "track-field": "https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=1200&q=80",
};

const Sports = () => {
  const { t } = useI18n();
  return (
    <>
      <section className="bg-[#0F1B2D] text-white pt-36 pb-20 relative grain">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="overline text-[#C4A46A]">{t.sports.kicker}</div>
          <h1 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight">
            {t.sports.title}
          </h1>
          <span className="gold-rule mt-8 block" />
        </div>
      </section>

      <section className="bg-[#F4F0E8]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {t.sports.list.map((s, i) => (
              <NLink
                key={s.slug}
                to={`/sports/${s.slug}`}
                data-testid={`sport-card-${s.slug}`}
                className="group block"
              >
                <div
                  className="aspect-[4/5] bg-cover bg-center relative overflow-hidden"
                  style={{ backgroundImage: `url(${SPORTS_IMG[s.slug]})` }}
                >
                  <div className="absolute inset-0 bg-[#0F1B2D]/40 group-hover:bg-[#0F1B2D]/20 transition-colors duration-500" />
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                    <div className="font-display text-[#C4A46A] text-sm">0{i + 1}</div>
                    <h3 className="mt-2 font-display text-2xl lg:text-3xl tracking-tight">{s.t}</h3>
                    <div className="mt-3 inline-flex items-center gap-2 text-[#C4A46A] text-[11px] tracking-[0.24em] uppercase font-bold">
                      {t.common.explore} <ArrowRight size={12} />
                    </div>
                  </div>
                </div>
              </NLink>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#0F1B2D] text-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24">
          <div className="overline text-[#C4A46A]">{t.sports.futureT}</div>
          <h2 className="mt-3 font-display text-3xl lg:text-4xl tracking-tight">{t.sports.futureT}</h2>
          <span className="gold-rule mt-6 block" />
          <p className="mt-8 max-w-2xl text-white/70 text-lg leading-relaxed">{t.sports.futureD}</p>
        </div>
      </section>
    </>
  );
};

export default Sports;
